import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";

import { themes } from "@/Components/Styling/themeConfigs";

type Props = {
  icon: keyof typeof MaterialIcons.glyphMap;
  label: string;
  value: string;
  isLast?: boolean;
  numberOfLines?: number;
};

function StatItem({
  icon,
  label,
  value,
  isLast = false,
  numberOfLines = 1,
}: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const iconSize = currentTheme.icon.size.web.large;
  const iconColor = currentTheme.icon.color;
  const textSize = currentTheme.typography.h3.size.web;
  const textColor = currentTheme.typography.h3.color;

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      borderRightWidth: isLast ? 0 : 1,
      borderRightColor: currentTheme.borderColor,
      paddingHorizontal: 24,
    },
    iconContainer: {
      justifyContent: "center",
      alignItems: "center",
    },
    textContainer: {
      marginLeft: 16,
      flex: 1,
    },
    label: {
      fontSize: textSize,
      color: textColor,
      marginBottom: 6,
    },
    value: {
      fontSize: textSize,
      color: textColor,
      fontWeight: "500",
    },
  });

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <MaterialIcons name={icon} size={iconSize} color={iconColor} />
      </View>
      <View style={styles.textContainer}>
        <Text style={styles.label}>{label}</Text>
        <Text
          numberOfLines={numberOfLines}
          style={styles.value}
          ellipsizeMode="tail"
        >
          {value}
        </Text>
      </View>
    </View>
  );
}

export default StatItem;
